export enum TOOLBOXS {
  SMALL = 'SMALL',
  LARGE = 'LARGE',
}

export enum BOXES_REFERENCE {
  FT = '5831362',
}

export enum RANGE_FOR_EXTRA_BOX_BELT {
  MIN = 30,
  MAX = 60
}

export enum RANGE_FOR_ALWAYS_LARGE_TOOLBOX {
  MIN = 15,
  MAX = 30
}

export const TOOLBOX_TIMES = {
  [TOOLBOXS.SMALL]: 6.53,
  [TOOLBOXS.LARGE]: 12.07,
};

export const ARTICLE_TYPES_LUMINAIRES = [1];

export const MAX_BELT_LENGTH = 15;

export const TRAY2_UBICATIONS_FOR_SMALL_TOOLBOX = 4;

export const MAX_CIRCULAR_ELEMENTS_BY_BOX_FT = 3;

export const MAX_REMAINDER_ELEMENTS_BY_BOX_FT = 15;

export const MAX_CORNER_SUPPORT_ELEMENTS_BY_BOX_FT = 2;

export const ARTICLE_TYPES_BELT = [22, 50];

export const EXTRA_TRAY_REFERENCE = '5831359'

export enum ARTICLE_TYPES_F_T {
  F1 = 37,
  F2 = 38,
  F3 = 39,
  F4 = 40,
  F5 = 41,
  T1 = 43,
  T2 = 44,
  T3 = 45,
  T4 = 46,
  T5 = 47,
  T6 = 48,
  T7 = 49,
}

export const ARTICLE_TYPES_CIRCULARS = [ARTICLE_TYPES_F_T.F1, ARTICLE_TYPES_F_T.F2];

export const ARTICLE_TYPES_REMAINDER = [
  ARTICLE_TYPES_F_T.T1,
  ARTICLE_TYPES_F_T.T2,
  ARTICLE_TYPES_F_T.T3,
  ARTICLE_TYPES_F_T.T4,
  ARTICLE_TYPES_F_T.T5,
  ARTICLE_TYPES_F_T.T6,
  ARTICLE_TYPES_F_T.T7,
  ARTICLE_TYPES_F_T.F3,
];

export const ARTICLE_TYPES_CORNER_SUPPORT = [ARTICLE_TYPES_F_T.F5];

export const ARTICLE_TYPES_COUNTERWEIGHT = [ARTICLE_TYPES_F_T.F4];
